import { css } from '@emotion/core';
import { media, variables } from '@domain-group/fe-brary';
// eslint-disable-next-line import/prefer-default-export

// TODO: optimise hero.jpg for each size (1300kb right now)
// TODO: get import/inline images working
// Have created a webp version to start.
export const container = css`
  width: 100%;
  padding-bottom: 30px;

  background: linear-gradient(
      89.24deg,
      #0b0b0b 15.01%,
      rgba(11, 10, 10, 0) 109.09%
    ),
    no-repeat url(/assets/hero-mobile.jpg) center, #000;
  ${media('>=tablet')} {
    height: 300px;
    padding-bottom: 0px;
    background: linear-gradient(
        89.25deg,
        #0b0b0b 15.01%,
        rgba(11, 10, 10, 0) 85.6%
      ),
      no-repeat url(/assets/hero-tablet.jpg) center, #000;
  }
  ${media('>=desktop')} {
    height: 455px;
    background: linear-gradient(
        90.43deg,
        #0b0b0b 0.44%,
        rgba(11, 10, 10, 0) 76.93%
      ),
      no-repeat url(/assets/hero-desktop.jpg) center, #000;
  }
  @media (min-width: 2200px) {
    height: 455px;
    background: linear-gradient(
        90.43deg,
        #0b0b0b 0.44%,
        rgba(11, 10, 10, 0) 76.93%
      ),
      linear-gradient(to left, #0b0b0b 15.01%, rgba(255, 255, 255, 0) 40%),
      no-repeat url(/assets/hero-desktop.jpg) center, #000;
  }
`;
// Note above: the final 2200px media query adds the `to left` gradient to cover the right hand of the hero image abruptly ending.

export const contentContainer = css`
  ${media('>=desktop')} {
    width: 1000px;
  }
  margin-left: auto;
  margin-right: auto;
`;

export const content = css`
  color: #fff;
  padding-top: 49px;
  margin-left: 18px;
  h1 {
    width: 100%;
    max-width: 339px;
    font-weight: 700;
    font-size: 26px;
    line-height: 32px;
  }
  p {
    width: 100%;
    max-width: 297px;
    padding-top: 24px;
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    padding-bottom: 24px;
  }

  ${media('>=tablet')} {
    padding-top: 49px;
    margin-left: 24px;
    h1 {
      max-width: 339px;
      width: 339px;
    }
    p {
      padding-top: 24px;
      max-width: 377px;
      width: 377px;
      padding-bottom: 32px;
    }
  }
  ${media('>=desktop')} {
    padding-top: 54px;
    margin-left: 0px;
    h1 {
      width: 489px;
      max-width: 489px;
      font-size: ${variables.font.h1FontSize};
      line-height: 54px;
    }
    p {
      padding-top: 24px;
      width: 433px;
      max-width: 433px;
      font-size: 18px;
      line-height: 30px;
      font-weight: 400;
      padding-bottom: 54px;
    }
  }
`;
